
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IOrder } from '@/model/Order/orderInterfaces';
import { TranslationHelper } from '@/helpers/TranslationHelper';
import { DateHelper } from '@/helpers/DateHelper';

const orderModule = namespace('orderModule');

@Component({ name: 'OrderPrint' })
export default class OrderPrint extends Vue {
  @Prop()
  protected orderId!: number;

  @orderModule.Getter('order')
  private order!: IOrder;

  protected loading: boolean = true;

  mounted() {
    if (!this.order || this.order.id !== this.orderId) {
      this.$store.dispatch('orderModule/fetchOrder', this.orderId).then(() => {
        this.loading = false;
        this.$nextTick(() => { window.print(); });
      });
    } else {
      this.loading = false;
      this.$nextTick(() => { window.print(); });
    }
  }

  get totalQuantity(): number {
    if (!this.order || !this.order.services) return 0;
    return this.order.services.reduce((sum: number, s: any) => sum + (s.quantity || 0), 0);
  }

  translateName(name: any): string {
    if (!name) return '—';
    if (typeof name === 'string') return name;
    return TranslationHelper.translateField(name) || '—';
  }

  formatDate(dateStr: string | null): string {
    if (!dateStr) return '—';
    const tz = this.order && this.order.community_timezone ? this.order.community_timezone : null;
    if (tz) {
      return DateHelper.dateFormatTz(dateStr, tz);
    }
    return DateHelper.dateFormat(dateStr);
  }

  doPrint() {
    window.print();
  }

  goBack() {
    this.$router.push({ name: 'order', params: { orderId: String(this.orderId) } });
  }
}
